import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowSquareUp = (props: SVGProps<SVGSVGElement>) => {
  return <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' fill='none' viewBox='0 0 24 24' {...props} data-sentry-element="svg" data-sentry-component="SvgArrowSquareUp" data-sentry-source-file="ArrowSquareUp.tsx">
            <path fill='currentColor' d='M15.53 14.21c-.19 0-.38-.07-.53-.22l-3-3-3 3c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l3.53-3.53c.29-.29.77-.29 1.06 0l3.53 3.53c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22' data-sentry-element="path" data-sentry-source-file="ArrowSquareUp.tsx" />
        </svg>;
};
export default SvgArrowSquareUp;